<template>
    <paginate
        v-model="page"
        :page-count="pagination.total_pages"
        :click-handler="clicked"
        :prev-text="$t('pagination.prev')"
        :next-text="$t('pagination.next')"
        container-class="p-4 w-full flex justify-center"
        page-link-class="px-4 py-2 rounded bg-gray-200 text-gray-600 mx-1"
        prev-link-class="px-4 py-2 rounded bg-gray-200 text-gray-600 mx-1"
        next-link-class="px-4 py-2 rounded bg-gray-200 text-gray-600 mx-1"
        active-class="!bg-primary !text-white"
        :no-li-surround="true"
        :hide-prev-next="true"
        v-if="pagination.total_pages > 1"
    >
    </paginate>
</template>

<script>
    import Paginate from 'vuejs-paginate';

    export default {
        components: {
            Paginate
        },
        props: {
            page: {
                type: Number,
                default: 1
            },
            pagination: {
                type: Object,
                required: true
            }
        },
        methods: {
            clicked(page) {
                this.$emit('click', page);
            }
        }
    }
</script>